const DEFAULT_MOVEMENT = {
    foreground: {
        scrollY: -1000,
        rotation: 1,
        scale: 3,
        floatMovement: 0.4,
    },
    midground: {
        scrollY: -500,
        rotation: 1,
        scale: 2,
        floatMovement: 0.2,
    },
    background: {
        scrollY: 0,
        rotation: 1,
        scale: 1,
        floatMovement: 0.05
    },
};
const SELECTORS = {
    context: '[data-component-parallax-stop]',
    asteroid: '.Asteroid',
};

function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
}

function deepMerge(target, source) {
    for (const key in source) {
        if (source[key] && typeof source[key] === 'object') {
            target[key] = deepMerge(target[key] || {}, source[key]);
        } else {
            target[key] = source[key];
        }
    }
    return target;
}

export default class AsteroidField {
    constructor(element, config = {} ) {
        this.element = element;
        this.context = this.element.closest(SELECTORS.context) ?? this.element;

        const defaultConfig = { movement: DEFAULT_MOVEMENT };
        this.config = deepMerge(deepMerge({}, defaultConfig), config);
        this.isDestroyed = false;
        this.progress = 0;

        this.asteroids = [
            ...this.element.querySelectorAll(SELECTORS.asteroid)
        ].map( ( node ) => {
            const depth = node.dataset.depth ?? 'midground';
            return {
                node,
                depth,
                movementMultiplier: randomBetween(0.85, 1.15),
                rotationMultiplier: randomBetween(0.7, 1.3),
                rotationDirection: Math.random() > 0.5 ? 1 : -1,
                rotationSpeed: randomBetween(0.6, 1.4),
                config: this.config.movement[depth] ?? this.config.movement.midground,
                floatOffset: Math.random() * Math.PI * 2,
                floatSpeed: randomBetween(0.4, 0.8),
                floatRadiusX: randomBetween(25,50),
                floatRadiusY: randomBetween(12,30),
            };
        });

        this.asteroids.forEach((asteroid) => {
            asteroid.node.style.setProperty('--scale', asteroid.config.scale);
        });

        // bind context for handlers
        this.measure = this.measure.bind(this);
        this.onScroll = this.onScroll.bind(this);

        // initial measurements
        this.measure();

        // setup event listeners
        window.addEventListener('resize', this.measure);
        window.addEventListener('scroll', this.onScroll, { passive: true });

        // initial position update
        this.onScroll();

        this.animate = this.animate.bind(this);
        this.animationFrame = requestAnimationFrame(this.animate);

        element.setAttribute('data-asteroid-field-initialized', '');
    }

    animate() {
        if( this.isDestroyed ) { return; }
        const time = performance.now() * 0.001;

        this.asteroids.forEach((asteroid) => {
            const t = time * asteroid.floatSpeed + asteroid.floatOffset;

            // figure-eight / lemniscate-ish path
            const floatX = Math.sin(t) * asteroid.floatRadiusX * asteroid.config.floatMovement;
            const floatY = Math.sin(t * 2) * asteroid.floatRadiusY * asteroid.config.floatMovement;

            const scrollY = this.progress * asteroid.config.scrollY * asteroid.movementMultiplier;
            // const rotation = this.progress * asteroid.config.rotation * asteroid.rotationMultiplier * asteroid.rotationDirection;
            // const rotation = Math.sin(time * asteroid.rotationMultiplier) * asteroid.config.rotation * asteroid.rotationDirection;
            // const rotation = time * asteroid.config.rotation * asteroid.rotationMultiplier * asteroid.rotationDirection;
            const rotation = time * asteroid.config.rotation * asteroid.rotationMultiplier * asteroid.rotationDirection * asteroid.rotationSpeed;

            asteroid.node.style.setProperty('--float-x', `${floatX}px`);
            asteroid.node.style.setProperty('--scroll-y', `${scrollY}%`);
            asteroid.node.style.setProperty('--float-y', `${floatY}px`);

            asteroid.node.style.setProperty('--r', `${rotation}deg`);
        });

        this.animationFrame = requestAnimationFrame(this.animate);
    }

    measure() {
        const rect = this.context.getBoundingClientRect();
        this.pageTop = rect.top + window.scrollY;
        this.height = this.context.offsetHeight;
        this.viewportHeight = window.innerHeight;
    }

    getProgress() {
        // const start = this.pageTop - ( this.viewportHeight * 0.5 );
        const start = this.pageTop - this.viewportHeight;
        const end = this.pageTop + this.height + this.viewportHeight;
        const rawProgress = (window.scrollY - start) / (end - start);
        return Math.max(0, Math.min(1, rawProgress));
    }

    onScroll() {
        this.progress = this.getProgress();

        /*
        this.asteroids.forEach((asteroid) => {

            const movementY =
                this.progress *
                asteroid.config.movement *
                asteroid.movementMultiplier;

            const rotation =
                this.progress *
                asteroid.config.rotation *
                asteroid.rotationMultiplier *
                asteroid.rotationDirection;

            asteroid.node.style.setProperty('--ty', `${movementY}%`);
            asteroid.node.style.setProperty('--r', `${rotation}deg`);
        });
        */
    }

    destroy() {
        this.isDestroyed = true;
        window.removeEventListener('resize', this.measure);
        window.removeEventListener('scroll', this.onScroll);
        cancelAnimationFrame(this.animationFrame);
    }

}